import React from "react";
import { useTranslation } from "react-i18next";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import useReportForm from "./useReportForm";
const Share = () => {
  const { t } = useTranslation("enterprise_report");
  const { values, setFieldValue } = useReportForm();
  const handleEntityShareSet = (entityShare) => setFieldValue("share_request", entityShare);
  return /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: t("share.description"),
      onSetEntityShare: handleEntityShareSet,
      defaultSharePayload: values == null ? void 0 : values.share_request,
      entityType: "report",
      entityTitle: ""
    }
  );
};
export default Share;
